import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
  standalone: false,
})
export class PromptComponent {
  matDialogRef = inject<MatDialogRef<PromptComponent>>(MatDialogRef);
  private data = inject<{
    title: string;
    message: string;
    inputName: string[];
    inputValue: string[];
    btnOkText: string;
    btnCancelText: string;
  }>(MAT_DIALOG_DATA);

  title: string;
  message: string;
  inputName: string[];
  inputValue: string[];
  btnOkText: string;
  btnCancelText: string;

  constructor() {
    this.title = this.data.title;
    this.message = this.data.message;
    this.inputName = this.data.inputName;
    this.inputValue = this.data.inputValue;
    this.btnOkText = this.data.btnOkText || 'Si';
    this.btnCancelText = this.data.btnCancelText || 'No';
  }
}
